import { defineSlotRecipe } from '@chakra-ui/react';
import { Colors, Space, Shadows, TextStyles } from '../../types';

export const accordionSlotRecipe = defineSlotRecipe({
  slots: ['root', 'item', 'itemTrigger', 'itemContent', 'itemBody', 'itemIndicator'],
  base: {
    item: {
      borderColor: Colors.BORDER_DEFAULT,
      _first: {
        borderTopColor: Colors.TRANSPARENT,
      },
      _last: {
        borderBottomColor: Colors.TRANSPARENT,
      },
    },
    itemIndicator: {
      color: Colors.ICON_BRAND,
      _disabled: {
        color: Colors.TEXT_DISABLED,
      },
    },
    itemTrigger: {
      transitionProperty: 'common',
      transitionDuration: 'normal',
      color: Colors.TEXT_EMPHASIS,
      _focusVisible: {
        boxShadow: Shadows.NONE,
        outline: '2px solid',
        outlineColor: Colors.BORDER_FOCUS,
        outlineOffset: '-1px',
      },
      _hover: {
        bg: Colors.SURFACE_TERTIARY_HOVER,
      },
      _active: {
        bg: Colors.SURFACE_TERTIARY_ACTIVE,
      },
      _expanded: {
        bg: Colors.SURFACE_TERTIARY,
      },
      _disabled: {
        color: Colors.TEXT_DISABLED,
        opacity: 1,
        cursor: 'not-allowed',
      },
      px: Space.XS,
      py: Space.XS,
      gap: 0,
      borderRadius: 0,
    },
    itemContent: {
      pt: Space['2XS'],
      px: Space.SM,
      pb: Space.SM,
      textStyle: TextStyles.P2,
    },
  },
  variants: {
    // Stock's default `size: md` sets its own trigger textStyle, and a variant beats base.
    size: {
      md: {
        itemTrigger: {
          textStyle: TextStyles.H4,
        },
      },
    },
  },
  defaultVariants: {
    size: 'md',
  },
});
